import React, { useState } from "react";
import CandidateCard from "./CandidateCard";

const CandidatesList = ({ t, data }) => {
  const directionsMap = {
    center: "Centre",
    south: "Sud",
    north: "Nord",
    east: "Est",
  };

  const directions = Object.keys(directionsMap).filter((direction) =>
    data.candidates.some(
      (item) => item.candidateRegion === directionsMap[direction]
    )
  );

  const [selectedTab, setSelectedTab] = useState(directions[0]);

  const renderContent = () => {
    const filteredCandidates = data.candidates.filter(
      (item) => item.candidateRegion === directionsMap[selectedTab]
    );

    return (
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2 items-start">
        {filteredCandidates.map((candidate) => (
          <CandidateCard
            key={candidate.candidateName}
            candidate={candidate}
            party={data.logo}
            translation={data.translation}
          />
        ))}
      </div>
    );
  };

  return (
    <div className="px-5 bg-white pt-10">
      <span className="text-22 font-medium md:text-32">
        {t("whoIsRunning")}
      </span>
      <div className="h-0.5 bg-black bg-opacity-40 mb-7"></div>
      <div className="flex">
        {directions.map((direction) => (
          <button
            key={direction}
            onClick={() => setSelectedTab(direction)}
            className={`
    py-2 mr-3 rounded h-12 w-20 md:w-32 
    ${
      selectedTab === direction
        ? "bg-primary text-white"
        : "bg-wort text-black hover:border-primary hover:text-primary"
    }
    hover:border-2 border-transparent transition-all duration-300
  `}
          >
            {t(direction)}
          </button>
        ))}
      </div>
      <div className="py-5">{renderContent()}</div>
    </div>
  );
};

export default CandidatesList;
